// Shared utility for calculating shift payment breakdown
// Used by both ShiftReportDialog and CashPickupDialog

export const calculatePaymentBreakdown = (transactions) => {
  const paymentBreakdown = {
    cash: 0,
    qris: 0,
    transfer: 0
  };

  transactions.forEach(t => {
    const method = (t.payment_method || 'cash').toLowerCase();
    
    // Use correct field based on transaction type
    let amount = 0;
    if (t.transaction_type === 'ps') {
      amount = t.final_price || t.total_price || 0;
    } else if (t.transaction_type === 'fnb') {
      amount = t.total || t.final_price || t.total_price || 0;
    }
    
    if (method.includes('qris')) {
      paymentBreakdown.qris += amount;
    } else if (method.includes('transfer') || method.includes('bank')) {
      paymentBreakdown.transfer += amount;
    } else {
      paymentBreakdown.cash += amount;
    }
  });

  return paymentBreakdown;
};
